const postRoles = {
  toastr: 'Función agregada',
  toastr: ' fue agregado con éxito',
  toastrError: 'Función ya registrada',
  toastrError: 'Ingrese otro nombre'
};

export default postRoles;
